import React, { useCallback } from 'react';
import { SWORN_DATA } from '../../gameData';
import { MerlinUpgrade } from '../../types';
import { SelectionPanel } from '../ui/SelectionPanel';
import { SelectableItem } from '../ui/SelectableItem';
import { MorganaToggleOption } from '../ui/MorganaToggle';

interface MerlinPanelProps {
  mode: 'single' | 'double';
  setMode: (mode: 'single' | 'double') => void;
  selectedUpgrades: string[];
  toggleUpgrade: (upgrade: string) => void;
}

const MerlinPanel: React.FC<MerlinPanelProps> = ({
  mode,
  setMode,
  selectedUpgrades,
  toggleUpgrade
}) => {
  const merlinUpgrades = SWORN_DATA.merlin_upgrades || [];
  const theme = SWORN_DATA.ui_theme?.colors || { merlin_blue: '#4f86e6', text_black: '#000000', morgana_gold: '#e6a84f' };
  const primaryColor = theme.merlin_blue || '#4f86e6';

  return (
    <SelectionPanel
      title="Merlin's Blessings"
      titleColor={primaryColor}
      toggleOptions={[{ label: 'Single Mod', value: 'single' }, { label: 'Double Mod', value: 'double' }] as [MorganaToggleOption<'single' | 'double'>, MorganaToggleOption<'single' | 'double'>]}
      toggleValue={mode}
      onToggleChange={setMode}
      toggleColors={{ primary: primaryColor, textOnPrimary: theme.text_black }}
      containerId="merlin-panel"
    >
      {merlinUpgrades.map((u: MerlinUpgrade) => {
        const selectionCount = selectedUpgrades.filter(m => m === u.name).length;
        const isSelected = selectionCount > 0;

        return (
          <SelectableItem
            key={u.name}
            id={u.name}
            title={u.name}
            subtitle={u.effect}
            isSelected={isSelected}
            badgeText={selectionCount > 1 ? 'x2' : 'Active'}
            themeColor={primaryColor}
            onClick={toggleUpgrade}
          />
        );
      })}
      {merlinUpgrades.length === 0 && <div style={{ color: theme.text_black }}>No Merlin upgrades found.</div>}
    </SelectionPanel>
  );
};

export default MerlinPanel;